import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'highlightSearch',
    standalone: false
})
export class HighlightSearchPipe implements PipeTransform {

  transform(value: any, args: any): string {
    if (value == null) {
      return '';
    }
    const text = this.escapeHtml(String(value));
    if (!args) {
      return text;
    }

    let regex: RegExp;
    try {
      regex = new RegExp(this.escapeRegex(String(args)), 'gi');
    } catch {
      return text;
    }

    return text.replace(regex, match => `<span class="highlight-search">${match}</span>`);
  }

  private escapeHtml(value: string): string {
    return value
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  private escapeRegex(value: string): string {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

}
